import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { authService, ChangePasswordRequest } from '@aslanpay/portal-common-lib';

const useChangePassword = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, ChangePasswordRequest>) => {
  return useMutation<unknown, Error, ChangePasswordRequest>(
    ({ cognitoUser, currentPassword, newPassword }: ChangePasswordRequest) =>
      authService.changePassword({ cognitoUser, currentPassword, newPassword }),
    { onSuccess, onError }
  );
};

export default useChangePassword;
